import React from "react";

export interface TimerBarProps {
    second: number;
    refreshRateInSeconds: number;
}

export default function TimerBar({second, refreshRateInSeconds}: TimerBarProps) {
    const progressPercentage = ((second % (refreshRateInSeconds + 1)) / refreshRateInSeconds) * 100;

    const width = `${Math.max(progressPercentage, 0)}%`;

    return (
        <div className="animate-smooth bg-tertiary"
             style={{height: '2px', width, minWidth: '1px', margin: 0, padding: 0}}>&nbsp;</div>
    );
}